import { passwordChecks } from '../lib/password'
import { Icon } from './layout/Icon'
import { useMessages } from '@/i18n/messages'
import { passwordMessages } from '@/i18n/text/password'

/**
 * Live requirement checklist shown under a password field. Each rule turns green
 * with a check the moment it's satisfied, so users get immediate feedback
 * instead of only seeing an error on submit. When `confirm` is provided, a
 * "passwords match" row is appended.
 */
export function PasswordChecklist({
  password,
  confirm,
  className = '',
}: {
  password: string
  confirm?: string
  className?: string
}) {
  const m = useMessages(passwordMessages)
  const checks = passwordChecks(password)
  if (confirm !== undefined) {
    checks.push({ label: m.checkMatch, met: password.length > 0 && password === confirm })
  }

  return (
    <ul className={`mt-2 space-y-1 ${className}`}>
      {checks.map((c) => (
        <li
          key={c.label}
          className={`flex items-center gap-1.5 text-xs transition-colors ${
            c.met ? 'text-emerald-600' : 'text-gray-400'
          }`}
        >
          <span
            className={`grid h-4 w-4 place-items-center rounded-full border ${
              c.met ? 'border-emerald-500 bg-emerald-500 text-white' : 'border-gray-300 text-transparent'
            }`}
          >
            <Icon name="check" className="h-3 w-3" />
          </span>
          {c.label}
        </li>
      ))}
    </ul>
  )
}
